import styled from "styled-components";

export const Banner = styled.div`
  &.show{
    height: 50px;
    width: 50px;
    z-index: 999999;
  }
  div {
    position: absolute;
    z-index: -1;
  }
`;

export const BannerPositionRight = styled.div`
  display: block;
  position: fixed;
  top: 227px;
  z-index: 10;
  right: 0; 
`;

export const BannerPositionLeft = styled.div`
  display: block;
  position: fixed;
  top: 227px;
  z-index: 10;
`;

export const BannerOverlay = styled.div`
  display: none; 
  position: fixed;
  top: 0;
  left: 0;
  background: #fff;
  height: 100%;
  width: 100%;
  z-index: 101;
  &.show {  
    display: flex;
    justify-content: center;
    align-items: center;
  }
  div{
    width: 100%;
    height: 100%;
  }
`;

export const Close = styled.button`
  cursor: pointer;
  background-color: hsl(349, 100%, 42%, .8);
  border: none;
  border-radius: 50px;
  color: white;
  padding: 10px 15px;
  font-family: system-ui;
  font-size: 20px;
  font-weight: 600;
  width: 50px;
  height: 50px;
  top: 30px;
  position: absolute;
  right: 30px;
  z-index: 102;
`;